/**
 * AppHostName object holds hostnames where QC is run from.
 */
export const AppHostName = {
  MSX: {
    Local: 'msxplatform.crm.dynamics.com',
    UAT: 'msxuat.crm.dynamics.com',
    Prod: 'microsoftsales.crm.dynamics.com',
    Perf: 'msxperf2.crm.dynamics.com',
    SQA: 'microsoftsales56-sb2.crm.dynamics.com',
    Dev: 'msxdev02.crm.dynamics.com',
    Support: 'msxsupportpoc.crm.dynamics.com',
    PreProd: 'msxpreprod1.crm.dynamics.com',
    FedSalesDev: 'fedsalesdev1.crm.dynamics.com',
    UsxDemo: 'usxdemo.crm.dynamics.com',
  },
};

export const isMsx = () => {
  switch (window.location.hostname) {
    case AppHostName.MSX.Local:
    case AppHostName.MSX.Dev:
    case AppHostName.MSX.Perf:
    case AppHostName.MSX.PreProd:
    case AppHostName.MSX.SQA:
    case AppHostName.MSX.Support:
    case AppHostName.MSX.UAT:
    case AppHostName.MSX.FedSalesDev:
    case AppHostName.MSX.UsxDemo:
      return true;
    case AppHostName.MSX.Prod:
      return true;
    default:
      return false;
  }
};
